import React from "react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { PAYMENT_METHODS } from "@/lib/reportFilters";

export default function PaymentMethodFilter({ value, onChange, className }) {
  return (
    <div className={className}>
      <Label className="text-[12px] text-slate-600 mb-1 block">Payment</Label>
      <Select value={value || "all"} onValueChange={onChange}>
        <SelectTrigger
          className="h-9 w-[180px]"
          data-testid="report-payment-method"
          data-report-filter
          data-report-filter-label="Payment"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAYMENT_METHODS.map((m) => (
            <SelectItem key={m.value} value={m.value}>
              {m.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
